import React, { useState, useEffect } from 'react';
import ImageGallery from '@/components/ImageGallery';

function ImageReviewOriginal() {
  const [uploadConfig] = useState({
    imageKind: "original",
    directory: "imported"
  });
  return (
    <ImageGallery
      imageKind={uploadConfig.imageKind}
      directory={uploadConfig.directory}
   />
  );
};

export default ImageReviewOriginal;